import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { init as sentryInit } from '@sentry/angular';

import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import { EnvironmentService } from './app/core/service/environment.service';

if (!['LOCAL', 'DEV'].includes(environment.env)) {
  sentryInit({
    dsn: 'https://8520f88c481b49699c3d735410eb786f@o4510888270102528.ingest.us.sentry.io/4510890233561088',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: environment.env,
    release: EnvironmentService.version,
    dist: environment.sentryDist
  });
}

if (environment.production) {
  /**
   * To enable PWA Service worker uncomment this code
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      navigator.serviceWorker.register('ngsw-worker.js');
    });
  }
   */
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err: any) => {
    throw err;
  });
